import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ParsevalsIdentity = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Parseval's Identity"
    videos={[
      "https://www.youtube.com/embed/J5t4YQqPVtU",
      "https://www.youtube.com/embed/q73jZ-38H7w",
      "https://www.youtube.com/embed/X05bB2UQijY",
      "https://www.youtube.com/embed/dsqK1oCBPmk",
    ]}
    takeaways={[]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default ParsevalsIdentity;
